import React from "react";
import { Outlet } from "react-router-dom";
import Header from "../../components/Header";
import Footer from "../../components/Footer";

function GradientHeaderLayout() {
  return (
    <>
      <Header gradient={true} />
      <main id="main-content" role="main">
        <Outlet />
      </main>
      <Footer />
    </>
  );
}

export default GradientHeaderLayout;
